module.exports = __webpack_public_path__ + "img/fig05.aaa4598c.jpg";